(function () {
    'use strict';

    run.admin.parts.keepAlive = function () {
        const csrfNameElement = document.getElementsByName('csrf_name');
        const csrfValueElement = document.getElementsByName('csrf_value');

        if (csrfNameElement.length == 0) {
            return;
        }

        if (csrfNameElement[0].value.length == 0) {
            return;
        }

        var data = new FormData();
        data.append('csrf_name', csrfNameElement[0].value);
        data.append('csrf_value', csrfValueElement[0].value);

        setInterval(() => {
            axios.post(GlobalRoutes.keepAlive, data)
            .then(function (response) {
                //console.log('Keep alive successful')
            })
            .catch(function (error) {
            });
        }, 300000); // every 5 minutes
    }
})();

